import React from 'react';
import { Xmark } from '@gravity-ui/icons';
import { Button } from '../Button';
import { ClipboardIcon } from '../ClipboardIcon';
import { CopyToClipboard } from '../CopyToClipboard';
import { Icon } from '../Icon';
import { block } from '../utils/cn';
import './Label.css';
const b = block('label');
const sizeMap = {
    xs: { copyIconSize: 12, closeIconSize: 12, buttonSize: 'xs' },
    s: { copyIconSize: 14, closeIconSize: 14, buttonSize: 's' },
    m: { copyIconSize: 16, closeIconSize: 16, buttonSize: 'm' },
};
const commonActionButtonProps = {
    pin: 'brick-round',
    className: b('addon', {
        side: 'right',
        interactive: true,
    }),
};
export const Label = React.forwardRef(function Label(props, ref) {
    const { type = 'default', theme = 'normal', size = 'xs', icon, children, onCloseClick, className, disabled, copyText, closeButtonLabel, copyButtonLabel, interactive = false, value, onCopy, onClick, qa, } = props;
    const hasContent = Boolean(children !== '' && React.Children.count(children) > 0);
    const typeClose = type === 'close' && hasContent;
    const typeCopy = type === 'copy' && hasContent;
    const hasOnClick = typeof onClick === 'function';
    const hasCopy = Boolean(typeCopy && copyText);
    const isInteractive = (hasOnClick || hasCopy || interactive) && !disabled;
    const { copyIconSize, closeIconSize, buttonSize } = sizeMap[size];
    const leftIcon = icon && (React.createElement("div", { className: b('addon', { side: hasContent ? 'left' : undefined }) }, icon));
    const content = hasContent && (React.createElement("div", { className: b('text') },
        React.createElement("div", { className: b('content') }, children),
        Boolean(value) && (React.createElement("div", { className: b('value') },
            React.createElement("div", { className: b('separator') }, ":"),
            React.createElement("div", { className: b('key') }, value)))));
    const renderLabel = (status) => {
        let actionButton;
        if (typeCopy) {
            actionButton = (React.createElement(Button, Object.assign({ size: buttonSize, extraProps: { 'aria-label': copyButtonLabel || undefined }, onClick: hasOnClick ? onClick : undefined, disabled: disabled }, commonActionButtonProps),
                React.createElement(Button.Icon, null,
                    React.createElement(ClipboardIcon, { status: status || 'pending', size: copyIconSize }))));
        }
        else if (typeClose) {
            actionButton = (React.createElement(Button, Object.assign({ onClick: onCloseClick, size: buttonSize, extraProps: { 'aria-label': closeButtonLabel || undefined }, disabled: disabled }, commonActionButtonProps),
                React.createElement(Icon, { size: closeIconSize, data: Xmark })));
        }
        return (React.createElement("div", { ref: ref, className: b({
                theme,
                size,
                type,
                'is-interactive': isInteractive,
                'has-right-addon': Boolean(actionButton),
                'has-left-addon': Boolean(leftIcon),
                disabled,
            }, className), "data-qa": qa },
            leftIcon,
            hasOnClick ? (React.createElement("button", { disabled: disabled, type: "button", onClick: onClick, className: b('action-button') }, content)) : (content),
            actionButton));
    };
    if (hasCopy && copyText && !hasOnClick) {
        return (React.createElement(CopyToClipboard, { text: copyText, onCopy: onCopy, timeout: 1000 }, (status) => renderLabel(status)));
    }
    return renderLabel();
});
